import React, { useState } from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";

const PRIMARY = "#429853";

/**
 * Gestion des thèmes d'un axe : renommer (enregistré au blur / Entrée),
 * supprimer (avec confirmation — les réponses classées repassent à « aucun »),
 * et ajouter.
 */
const ThemeEditor = ({ show, onHide, question, usage, onRename, onDelete, onCreate }) => {
  const [newLibelle, setNewLibelle] = useState("");

  if (!question) {
    return null;
  }
  const themes = question.themes || [];

  const handleRenameBlur = (theme, value) => {
    const libelle = value.trim();
    if (libelle && libelle !== theme.libelle) {
      onRename(theme, libelle);
    }
  };

  const handleDelete = (theme) => {
    const n = usage[theme.id] || 0;
    const detail =
      n > 0
        ? `\n${n} réponse${n > 1 ? "s" : ""} classée${n > 1 ? "s" : ""} dessus repassera${
            n > 1 ? "ont" : ""
          } à « aucun ».`
        : "";
    if (window.confirm(`Supprimer le thème « ${theme.libelle} » ?${detail}`)) {
      onDelete(theme);
    }
  };

  const handleCreate = () => {
    const libelle = newLibelle.trim();
    if (libelle) {
      onCreate(libelle);
      setNewLibelle("");
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Thèmes — {question.code}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ color: "#666", fontSize: 13 }}>
          Renomme un thème directement dans son champ (enregistré en quittant le champ). La
          suppression déclasse les réponses concernées (thème « aucun »), sans toucher aux
          verbatims.
        </p>

        <Table size="sm" borderless>
          <tbody>
            {themes.map((t) => (
              <tr key={t.id}>
                <td>
                  <Form.Control
                    size="sm"
                    defaultValue={t.libelle}
                    key={t.id + "-" + t.libelle}
                    onBlur={(e) => handleRenameBlur(t, e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
                  />
                </td>
                <td style={{ width: 90, verticalAlign: "middle", fontSize: 12, color: "#888" }}>
                  {usage[t.id] || 0} rép.
                </td>
                <td style={{ width: 40, verticalAlign: "middle" }}>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    style={{ padding: "0 6px" }}
                    title="Supprimer ce thème"
                    onClick={() => handleDelete(t)}
                  >
                    ×
                  </Button>
                </td>
              </tr>
            ))}
            {themes.length === 0 && (
              <tr>
                <td colSpan={3} style={{ color: "#888", fontSize: 13 }}>
                  Aucun thème sur cet axe.
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
          <Form.Control
            size="sm"
            placeholder="Nouveau thème…"
            value={newLibelle}
            onChange={(e) => setNewLibelle(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleCreate()}
          />
          <Button
            size="sm"
            style={{ background: PRIMARY, border: "none", whiteSpace: "nowrap" }}
            onClick={handleCreate}
          >
            Ajouter
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ThemeEditor;
